import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Owner } from 'app/core/panel/panel.models';
import { PanelStore } from 'app/core/panel/panel-store.service';

/**
 * Etykieta firmy pozycji (Issue 26) — tylko na koncie z firmami powiązanymi; konto z jedną firmą bez zmian.
 */
@Component({
    selector: 'vz-owner',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { style: 'display: contents' },
    template: `
        @if (label(); as l) {
            <span class="vz-owner" [attr.title]="owner()?.name">{{ l }}</span>
        }
    `,
})
export class VzOwnerComponent {
    private readonly store = inject(PanelStore);

    readonly owner = input<Owner | null | undefined>(null);

    protected readonly label = computed(() => this.store.ownerLabel(this.owner()));
}
